// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3l1SG","signatureBlock":"Footer_signatureBlock__32YvH","signature":"Footer_signature__3k_nr"};